import { defineEntity, custom } from './_helpers.js';

export default defineEntity('objective', {
    'risk.linked': custom({ scope: 'state' }),
    'risk.unlinked': custom({ scope: 'state' }),
    'treatment.linked': custom({ scope: 'state' }),
    'treatment.unlinked': custom({ scope: 'state' }),
    'kpi.linked': custom({ scope: 'state' }),
    'kpi.unlinked': custom({ scope: 'state' }),
    'initiative.linked': custom({ scope: 'state' }),
    'initiative.unlinked': custom({ scope: 'state' }),
});
